import axios from 'axios';
import WixConfig from '../../config/wix';
import Instance from '../../utilities/instance';

axios.defaults.baseURL = WixConfig.backendApiBaseUrl;
axios.defaults.headers.common.Accept = 'application/json';
const instance = Instance.get();
axios.defaults.headers.common.Authorization = instance;

const authAxios = axios.create({});

authAxios.interceptors.request.use(
  config => {
    return config;
  },
  async error => await Promise.reject(error)
);

authAxios.interceptors.response.use(
  response => {
    return response.data;
  },
  async error => await Promise.reject(error)
);

export { authAxios };
